import { injectable } from 'tsyringe';
import { IOWCustomURLWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-custom-url-wrapper.interface';

// -------------------------------------------------------------
@injectable()
export class OWCustomURLWrapper implements IOWCustomURLWrapper {
  // -------------------------------------------------------------
  public openNotificationsSettings() {
    window.location.href = 'overwolf://settings/notifications';
  }
}
